module.exports = __webpack_public_path__ + "img/hzserive1.d8b1d86c.jpg";